import NewPackage from "../../../../components/@repositories/packages/NewPackage";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PackageNewPage() {

    return (
        <NewPackage 
            routeType={routeTypes.workstation}
        />
    )
}